import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    attrs: {
      top: "15%",
      title: "账号设置",
      visible: _vm.dialogVisible,
      width: "500px",
      "close-on-click-modal": false,
      "append-to-body": "",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      "status-icon": "",
      model: _vm.form,
      rules: _vm.rules,
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "账号名称",
      prop: "name"
    }
  }, [_c("el-input", {
    staticClass: "inputText",
    attrs: {
      disabled: _vm.disabled,
      autocomplete: "off",
      placeholder: "请输入账号名称"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.save();
      }
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "账号头像",
      prop: "image"
    }
  }, [_c("el-upload", {
    staticClass: "avatar-uploader",
    attrs: {
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload,
      headers: _vm.uploadHeaders,
      "show-file-list": false,
      action: _vm.uploadUrl + "admin/v1/file/uploadFileImg"
    }
  }, [_vm.imageUrl ? _c("img", {
    staticClass: "avatar",
    attrs: {
      src: _vm.imageUrl
    }
  }) : _c("i", {
    staticClass: "el-icon-plus avatar-uploader-icon-material"
  })])], 1)], 1), _c("div", {
    staticClass: "bottomDiv"
  }, [_c("el-button", {
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("关闭")]), _c("el-button", {
    attrs: {
      disabled: _vm.disabled,
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };